export const API_PANEL_SERVICES = 'services';
export const API_PANEL_EXPLORER = 'explorer';
export const API_PANEL_DEBUGGER = 'debugger';

export type API_PANEL_ID = typeof API_PANEL_SERVICES | typeof API_PANEL_EXPLORER | typeof API_PANEL_DEBUGGER;
